<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" label-width="120px" :model="form" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="sysId">
          <el-select v-model="form.sysId"  clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="custId">
          <el-select v-model="form.custId"  clearable filterable placeholder="请选择客户名称">
            <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in form.cusData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户名称" prop="accountName">
          <el-input style="width: 217px;"  placeholder="请输入账户名称" clearable v-model="form.accountName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户编号"  prop="accountId">
          <el-input style="width: 217px;"  placeholder="请输入账户编号" clearable v-model="form.accountId" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="快照日期" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <!-- <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="addAccount" icon="el-icon-plus"></el-button> -->
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.accName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.accId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户余额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.balance }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="当日消费金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.dailyConsumeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="快照时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.snapshotTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'customerAccount',
  data () {
    return {
      form: {
        custId: '',
        sysId: '',
        cusData: [],
        accountId: '',
        accountName: '',
        date: ''
      },
      editable: false,
      tooltip: true,
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.custId = ''
      this.form.accountName = ''
      this.form.date = ''
      this.form.accountId = ''
    },
    initData () {
      let _this = this
      if (!this.sysData.length) {
        this.$store.dispatch('getSystem') // 请求业务系统
      }
      this.$axios({
        url: _this.$API.rechargeManagement.queryCustSimpleInfoList,
        method: 'post',
        data: {}
      }).then((response) => {
        if (!response.data.resData) return
        _this.form.cusData = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.accId = this.form.accountId
      op.accName = this.form.accountName
      op.custId = this.form.custId
      op.sysIds = sysIds
      op.startTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
      op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.accountManagement.queryCustomerBalanceSnapshotListByPage,
        // url: 'http://172.16.9.73:5010/agw/custAccountCtr/queryCustomerBalanceSnapshotListByPage',
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/accountManagement/cusBalance.vue